<template>
  <tbody>
      <tr v-if="!datas">
          <td colspan="5">加载中......</td>
      </tr>
      <template v-if="datas && datas.length">
          <tr v-for="(data, index) in datas">
            <td class="ushk-rili_content-time">{{ data.date | dateFormat('yyyy-MM-dd') }}</td>
            <td>
              {{ data.country }}
            </td>
            <td>{{ data.exchangename }}</td>
            <td>{{ data.holidayname }}</td>
            <td>
                <p class="ushk-table_alignLeft">{{ data.note }}</p>
            </td>
          </tr>
      </template>
      <tr v-else>
          <td colspan="5">今日无假期休市安排</td>
      </tr>
  </tbody>
</template>
<script>
  export default {
    props: {
      datas: {
        type: [Array, Boolean],
        default: false
      }
    },
    data () {
      return {
      }
    }
  }
</script>


// WEBPACK FOOTER //
// HolidayList.vue?46008996